import React, { Component } from 'react'
import { get, map } from 'lodash'
import DateTooltip from './DateTooltip'
import DownloadLink from './DownloadLink'
import csvUtil from '../utils/csv.util'

export interface TableVerticalHeader {
  heading: string
  path: string
  date?: boolean
  downloadText?: string
  tooltip?: string
}

export interface TableVerticalData extends Record<string, any> {}

interface TableVerticalProps {
  headers: TableVerticalHeader[]
  data: TableVerticalData | null
}

export default class TableVertical extends Component<TableVerticalProps> {
  date (value: string, tooltipText: string) {
    return (
      <DateTooltip
        date={value}
        tooltip={tooltipText} />
    )
  }

  dataValue (header: TableVerticalHeader) {
    const { path, date, tooltip, downloadText } = header
    const { data } = this.props
    const value = get(data, path)
    const tooltipText = tooltip ? get(data, tooltip) : null
    if (date) {
      return this.date(value, tooltipText)
    } else if (downloadText) {
      const text = get(data, downloadText)
      const sanitizedText = csvUtil.sanitizeFilename(text)
      return <DownloadLink path={value} text={sanitizedText} />
    } else return value
  }

  get dataRows () {
    return map(this.props.headers, header => {
      const { heading } = header
      return (
        <tr key={heading}>
          <th className="table-head">{heading}</th>
          <td className="table-data">{this.dataValue(header)}</td>
        </tr>
      )
    })
  }

  render () {
    return (
      <div className="table-responsive">
        <table className="table-default">
          <tbody>{this.dataRows}</tbody>
        </table>
      </div>
    )
  }
}
